import React from 'react';

import { StyledAdditionalBaseOptionList } from './AdditionalBaseOptionList.styles';

import { AdditionalBaseOptionListProps } from './AdditionalBaseOptionList.types';

import { AdditionalBaseOption as CoreAdditionalBaseOption } from '../../';

const AdditionalBaseOptionList = ({
  additionalBaseOptionComponent:
    AdditionalBaseOption = CoreAdditionalBaseOption,
  additionalBaseOptionDataList,
  componentClassname = 'additional-base-option-list',
  customClassnames = '',
  customStyle = '',
}: AdditionalBaseOptionListProps) => {
  if (!additionalBaseOptionDataList?.length) {
    return null;
  }
  return (
    <StyledAdditionalBaseOptionList
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
    >
      {additionalBaseOptionDataList.map((additionalBaseOptionData, index) => (
        <AdditionalBaseOption key={index} {...additionalBaseOptionData} />
      ))}
    </StyledAdditionalBaseOptionList>
  );
};
AdditionalBaseOptionList.displayName = 'AdditionalBaseOptionList';

export default AdditionalBaseOptionList;
